import { remotePropertiesStore } from 'state/store';
import { FeaturesListType } from 'useCase/featureFlags/types';

export const selectRemoteProperties = (): FeaturesListType | null => {
    return remotePropertiesStore.remoteProperties;
};
